export enum LogoutType {
    LogoutButton,
    Inactivity,
}
